import { userApi } from './index';
import { config } from '../config';
import { IptvAccount, IUserAvailableServices } from '../../../models/Accounts';

interface DeleteIptvDeviceProps {
  accountId: string | number;
  deviceId: number;
}

interface AddIptvDeviceProps {
  accountId: string | number;
  login?: string;
  password?: string;
  mac?: string;
}

interface EditIptvDeviceProps extends AddIptvDeviceProps {
  deviceId: number;
}

interface EditBrizTvProps {
  email?: string;
  phone?: string;
  password?: string;
  accountId: string | number;
  currentPassword: string;
}

interface CreateBrizTvProps extends Omit<EditBrizTvProps, 'password'> {
  password: string;
}

interface ActivationShareProps {
  accountId: string;
  shareId: string;
}

export const iptvApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    getIptvInfo: build.query<IptvAccount, { accountId: string | number }>({
      query: ({ accountId }) => ({
        url: config.IPTV.ACCOUNT_INFO(accountId),
      }),
      providesTags: () => ['Accounts'],
    }),
    getAvailableIptvServices: build.query<IUserAvailableServices, { accountId: string | number }>({
      query: ({ accountId }) => ({
        url: config.IPTV.SERVICES_AVAILABLE(accountId),
      }),
      providesTags: () => ['Accounts'],
    }),
    deleteDevice: build.mutation<{ success: boolean }, DeleteIptvDeviceProps>({
      query: ({ deviceId, accountId }) => ({
        url: config.IPTV.DELETE_OR_EDIT_DEVICE(accountId, deviceId),
        method: 'DELETE',
      }),
      invalidatesTags: ['Accounts'],
    }),
    addDevice: build.mutation<{ success: boolean }, AddIptvDeviceProps>({
      query: ({ accountId, mac, login, password }) => ({
        url: config.IPTV.ADD_DEVICE(accountId),
        method: 'POST',
        body: {
          mac,
          login,
          password,
        },
      }),
      invalidatesTags: ['Accounts'],
    }),
    editDevice: build.mutation<{ success: boolean }, EditIptvDeviceProps>({
      query: ({ accountId, mac, login, password, deviceId }) => ({
        url: config.IPTV.DELETE_OR_EDIT_DEVICE(accountId, deviceId),
        method: 'PUT',
        body: {
          mac,
          login,
          password,
        },
      }),
      invalidatesTags: ['Accounts'],
    }),
    connectBrizTv: build.mutation<{ success: boolean }, Omit<CreateBrizTvProps, 'currentPassword'>>({
      query: ({ email, phone, password, accountId }) => ({
        url: config.IPTV.BRIZ_TV_OLD(accountId),
        method: 'POST',
        body: {
          email,
          phone,
          password,
        },
      }),
    }),
    editBrizTv: build.mutation<{ success: boolean }, EditBrizTvProps>({
      query: ({ email, phone, password, accountId, currentPassword }) => ({
        url: config.IPTV.BRIZ_TV(accountId),
        method: 'PUT',
        body: {
          email,
          phone,
          password,
          currentPassword,
        },
      }),
      invalidatesTags: ['Accounts'],
    }),
    activationShare: build.mutation<{ success: boolean }, ActivationShareProps>({
      query: ({ accountId, shareId }) => ({
        url: config.IPTV.CONNECT_SHARE(accountId, shareId),
        method: 'POST',
      }),
      invalidatesTags: ['Accounts'],
    }),
  }),
});
